import {
    AUTH_ENDPOINTS,
    USER_ENDPOINTS
} from "../constants/apiEndpoints";
import { getWrapper, postWrapper } from "../utils/Wrapper";




export const loginUser = async (credentials) => {
const url = `${AUTH_ENDPOINTS.LOGIN}`;
  return postWrapper(url,credentials);
};
// export const loginUser = async (credentials) => {
//   try {
//     const response = await axiosInstance.post(AUTH_ENDPOINTS.LOGIN, {
//       email: credentials.email,
//       password: credentials.password,
//       confirmPassword: credentials.confirmPassword,
//     });

//     if (response.data.responseCode === 1) {
//       const { data } = response.data;
//       if (data) {
//         showToast(data, "warning");
//       }

//       localStorage.setItem("token", response.data.token);
//       localStorage.setItem("user", JSON.stringify(response.data.user));
//       return response.data;
//     } else {
//       throw new Error(response.data.responseMessage || "Login failed");
//     }
//   } catch (error) {
//     console.error("Login error in service:", error);
//     throw error.response?.data || error.message || "Login failed";
//   }
// };

export const logoutUser = async () => {
const url = `${AUTH_ENDPOINTS.LOGOUT}`;
  return postWrapper(url,{});
};

// export const logoutUser = async () => {
//   try {
//     const token = localStorage.getItem("token");
//     const response = await axiosInstance.post(
//       AUTH_ENDPOINTS.LOGOUT,
//       {},
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     );

//     // For debugging - remove in production
//     localStorage.removeItem("token");
//     localStorage.removeItem("user");
//     return response.data;
//   } catch (error) {
//     console.error("Logout error in service:", error);
//     localStorage.removeItem("token");
//     localStorage.removeItem("user");
//     throw error.response?.data || error.message || "Logout failed";
//   }
// };


export const changePassword = async (data) => {
const user = JSON.parse(localStorage.getItem("user"));
    const requestBody = {
      uuid: user.userId,
      oldPassword: data.oldPassword,
      password: data.password || data.newPassword,
      confirmPassword: data.confirmPassword,
    };
const url = `${AUTH_ENDPOINTS.RESET_USER_PASSWORD}`;
  return postWrapper(url,requestBody);
};
// export const changePassword = async (data) => {
//   try {
//     const token = localStorage.getItem("token");

//     if (!token) {
//       throw new Error("Authentication required");
//     }

//     const user = JSON.parse(localStorage.getItem("user"));

//     if (!user || !user.userId) {
//       throw new Error("User information not found");
//     }

//     const url = `${API_BASE_URL}${AUTH_ENDPOINTS.RESET_USER_PASSWORD}`;

//     // Prepare the request payload according to the submitPassword API requirements
//     const requestBody = {
//       uuid: user.userId,
//       oldPassword: data.oldPassword,
//       password: data.password || data.newPassword,
//       confirmPassword: data.confirmPassword,
//     };
//     const response = await fetch(url, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//         Accept: "application/json",
//       },
//       body: JSON.stringify(requestBody),
//     });

//     const responseData = await response.json();
//     if (responseData.responseCode === 0) {
//       throw new Error(responseData.responseMessage);
//     }

//     return responseData;
//   } catch (error) {
//     console.error("Change password error:", error);
//     throw error;
//   }
// };


export const getUserUUID = async () => {
const url = `${USER_ENDPOINTS.PROFILE}`;
  return getWrapper(url);
};

// export const getUserUUID = async (username) => {
//   try {
//     const token = localStorage.getItem("token");

//     if (!token) {
//       throw new Error("Authentication required");
//     }

//     const response = await fetch(`${API_BASE_URL}${USER_ENDPOINTS.PROFILE}`, {
//       method: "GET",
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     });

//     if (!response.ok) {
//       throw new Error("Failed to get user profile");
//     }

//     const userData = await response.json();
//     return userData.uuid;
//   } catch (error) {
//     console.error("Error getting user UUID:", error);
//     throw error;
//   }
// };

// export const forgotPassword = async (email) => {
//   try {
//     const response = await axiosInstance.post(
//       `${AUTH_ENDPOINTS.FORGOT_PASSWORD}?email=${email}`
//     );
//     return response.data;
//   } catch (error) {
//     console.error("Forgot password error:", error);
//     throw (
//       error.response?.data ||
//       error.message ||
//       "Failed to process forgot password request"
//     );
//   }
// };

export const forgotPassword = async (email) => {
const url = `${AUTH_ENDPOINTS.FORGOT_PASSWORD}?email=${email}`;
  return postWrapper(url);
};

// export const resetPassword = async (resetData) => {
//   try {
//     const response = await axiosInstance.post(AUTH_ENDPOINTS.RESET_PASSWORD, {
//       uuid: resetData.uuid,
//       token: resetData.token,
//       password: resetData.password,
//       confirmPassword: resetData.confirmPassword,
//     });
//     return response.data;
//   } catch (error) {
//     console.error("Reset password error:", {
//       message: error.message,
//       response: error.response?.data,
//       status: error.response?.status,
//     });
//     throw error;
//   }
// };

export const resetPassword = async (resetData) => {
const url = `${AUTH_ENDPOINTS.RESET_PASSWORD}`;
  return postWrapper(url,resetData);
};

export const validatePassword = async (password,
  username = "",
  phoneNumber = "") => {
        const data = {
      username: username || "defaultUser",
      phoneNumber: phoneNumber || "0000000000",
      password: password,
      conditions: {
        noSeqPattern: true,
        noPersonalData: true,
        minChar: 8,
        maxChar: 12,
        initialUpperCase: true,
      },
    };
const url = `${AUTH_ENDPOINTS.VALIDATE_PASSWORD}`;
  return postWrapper(url,data);
};

// export const validatePassword = async (
//   password,
//   username = "",
//   phoneNumber = ""
// ) => {
//   try {
//     const payload = {
//       username: username || "defaultUser",
//       phoneNumber: phoneNumber || "0000000000",
//       password: password,
//       conditions: {
//         noSeqPattern: true,
//         noPersonalData: true,
//         minChar: 8,
//         maxChar: 12,
//         initialUpperCase: true,
//       },
//     };

//     const response = await axios.post(
//       `${API_BASE_URL}${AUTH_ENDPOINTS.VALIDATE_PASSWORD}`,
//       payload,
//       {
//         headers: {
//           "Content-Type": "application/json",
//         },
//       }
//     );

//     return response.data;
//   } catch (error) {
//     console.error("Password validation error:", error);
//     return {
//       responseCode: 0,
//       responseMessage:
//         error.response?.data?.responseMessage ||
//         error.message ||
//         "Password validation failed",
//     };
//   }
// };

export const tockenExchange = async (token) => {
const url = `/token-exchange?Authorization=Bearer ${token}`;
  return postWrapper(url,{});
};
